export default {"src":"/_next/static/media/swiss-server.3956c903.svg","height":28,"width":140,"blurWidth":0,"blurHeight":0};